export const locales = ["en", "de", "fr", "it"] as const;
export type Locale = (typeof locales)[number];
export const defaultLocale: Locale = "en";

/** localStorage: "system" | Locale */
export const LOCALE_STORAGE_KEY = "taawn.locale";

export function isLocale(s: string): s is Locale {
	return (locales as readonly string[]).includes(s);
}
